import appConfig from "../app-config.json";

export class Defaults {
  private static instance: Defaults;

  // private constructor() {}

  static getInstance(): Defaults {
    if (!this.instance) {
      this.instance = new Defaults();
    }
    return this.instance;
  }

  get processingFee(): number {
    return appConfig.processing_fee;
  }

  get policyLength(): number {
    return appConfig.policy_length;
  }

  get hasReplacementCost(): boolean {
    return appConfig.replacement_cost;
  }

  get hasWaterSewer(): boolean {
    return appConfig.water_sewer_included;
  }

  get nssiApiKey(): string {
    return appConfig.nssi.api_key;
  }

  get nssiCustomerId(): string {
    return appConfig.nssi.customer_id;
  }

  get nssiPromoCode(): string {
    return appConfig.nssi.promo_code;
  }

  get nssiUserType(): string {
    return appConfig.nssi.user_type;
  }

  get nssiProductCode(): string {
    return appConfig.nssi.product_code;
  }

  get nssiClassCode(): string {
    return appConfig.nssi.class_code;
  }

  get nssiCoverageType(): string {
    return appConfig.nssi.coverage_type;
  }

  get nssiBillToRoleType() {
    return appConfig.nssi.bill_to_role_type;
  }

  get nssiLeadType() {
    return appConfig.nssi.lead_type;
  }

  get nssiPaymentCompany() {
    return appConfig.nssi.payment_company;
  }

  get nssiCreationUser() {
    return appConfig.nssi.creation_user;
  }

  get nssiPaymentMethodType() {
    return appConfig.nssi.payment_method_type;
  }

  get assurantPass(): string {
    return appConfig.assurant.pass;
  }

  get assurantPartnerId(): string {
    return appConfig.assurant.partner_id;
  }

  get assurantClientId(): string {
    return appConfig.assurant.client_id;
  }

  get assurantProgramType(): string {
    return appConfig.assurant.program_type;
  }

  get assurantBranch(): string {
    return appConfig.assurant.branch;
  }

  get assurantProductType(): string {
    return appConfig.assurant.product_type;
  }

  get assurantJobNumber(): string {
    return appConfig.assurant.job_number;
  }

  get assurantPmc(): string {
    return appConfig.assurant.pmc;
  }

  get assurantPropertyId(): string {
    return appConfig.assurant.property_id;
  }

  get monthlyProcessingFee(): number {
    return appConfig.monthly_processing_fee;
  }

  get reCaptchaKey(): string {
    return appConfig.re_captcha_key;
  }
}
